import { AlertColor } from "../../customEnums/AlertColor";
import { getBackgroundColor, getBorderColor, getIconColor } from "../../customStyles/common";

export const getAlertStyle = (severity: AlertColor) => ({
    backgroundColor: getBackgroundColor(severity),
    borderColor: getBorderColor(severity),
    border: "1px solid",
    ".MuiAlert-icon": {
        color: getIconColor(severity),
    },
});

export const getAlertTextColor = (severity: AlertColor) => getIconColor(severity);
